import React from "react";
import axios from "axios";
import { Link } from "gatsby";
import { Link as ScrollLink } from "react-scroll";
import { Container, Row, Col } from "react-bootstrap";
import logoLight from "../assets/images/logo/jci-logo.png";
// import FooterEvents from "./footer-events";
// import FooterPrograms from "./footer-programs";
import FooterPlayStore from "./footer-play-store";
import FooterAppStore from "./footer-app-store";
import FooterQuickLinks from "./footer-quick-links";
import { version } from "../../package.json";

var CurrentYear = new Date().getFullYear();

var Api_url = process.env.GATSBY_API_URL;

const axiosConfig = {
  headers: {
    "Content-Type": "application/json; text/html; charset=UTF-8",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers":
      "Origin, X-Requested-With, Content-Type, Accept",
  },
};

class Footer extends React.Component {
  constructor() {
    super();
    this.state = {
      VersionInfo: ""
    };
  }
  getVersionInfo = async () => {
    console.log("getVersionInfo called ");
    var url = Api_url + `/api/pages/version-info`;
    console.log("url=" + url);
    var postData = {
      UserInterface: 2
    };
    console.log({ postData });
    await axios
      .post(url, postData, axiosConfig)
      .then((res) => {
        console.log("RESPONSE RECEIVED: ", res);
        console.log("res=" + JSON.stringify(res));

        var records = res.data.records;
        console.log({ records });
        this.setState({ VersionInfo: records, });
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
      });
  };
  componentDidMount() {
    console.log("componentDidMount called ");
    // window.location.replace('https://www.google.com')
    this.getVersionInfo();
  }

  render() {
    return (
      <section className="site-footer">
        <div className="main-footer pt-142 pb-80">
          <Container>
            <Row>
              <Col lg={3} md={6} sm={12}>
                <div className="footer-widget mb-40 footer-widget__about">
                  <Link to="/">
                    <img
                      src={logoLight}
                      className="footer-widget__logo"
                      width="101"
                      alt=""
                    />
                  </Link>
                  <p>
                    JCI India is the Second largest Member Nation of Junior
                    Chamber International. Currently we are active in more than 26
                    states and union territories across India.
                  </p>
                  <ul className="list-unstyled footer-widget__contact">
                    <li>
                      <a href="#none">
                        <i className="azino-icon-telephone"></i>(022)-71117112
                      </a>
                    </li>
                    <li>
                      <a href="#none">
                        <i className="azino-icon-email"></i>support@jciindia.in
                      </a>
                    </li>
                    <li>
                      <a href="#none">
                        <i className="azino-icon-pin"></i>National Head Quarters{" "}
                        <br />
                        506 Windfall, Sahar Plaza, <br /> J.B. Nagar, Andheri
                        (EAST) <br />
                        Mumbai 400 059
                      </a>
                    </li>
                  </ul>
                </div>
              </Col>
              <Col lg={3} md={6} sm={12}>
                <FooterQuickLinks />
              </Col>
              <Col lg={3} md={6} sm={12}>
                <FooterPlayStore />
              </Col>
              <Col lg={3} md={6} sm={12}>
                <FooterAppStore />
              </Col>
              {/* <Col lg={3} md={6} sm={12}>
              <div className="footer-widget mb-40 footer-widget__newsletter">
                <h3 className="footer-widget__title">Newletter</h3>
                <p>Signup now to get daily latest news & updates from us</p>
                <form
                  data-url="https://xyz.us18.list-manage.com/subscribe/post?u=20e91746ef818cd941998c598&id=cc0ee8140e"
                  className="footer-widget__newsletter-form mc-form"
                >
                  <label htmlFor="mc-email" className="sr-only">
                    Email Address
                  </label>
                  <input
                    type="email"
                    name="EMAIL"
                    id="mc-email"
                    className=""
                    placeholder="Email address"
                  />
                  <div className="footer-widget__newsletter-btn-wrap d-flex justify-content-end">
                    <button type="submit" className="thm-btn ">
                      Subscribe Now
                    </button>
                  </div>
                </form>
                <div className="mc-form__response"></div>
              </div>
            </Col> */}
            </Row>
          </Container>
        </div>
        <div className="footer-bottom">
          <div className="container" style={{ padding: "30px", display: "block" }}>
            <Row>
              <ScrollLink
                to="wrapper"
                smooth={true}
                duration={500}
                className="scroll-to-top"
              >
                <i className="far fa-angle-up"></i>
              </ScrollLink>
              <Col lg={4} md={6} sm={12}>
                <p>© Copyright {CurrentYear} by JCI India &nbsp;&nbsp; Version {version}
                </p>
              </Col>
              <Col lg={4} md={6} sm={12}>
                <p>
                  {" "}
                  {/* Crafted with <i className="fas fa-heart text-white"></i> by <a href="http://vaagai.org.in" target="_blank"> Vaagai
              Tecknowledge </a> */}
                  Crafted by Artisans of <a href="http://vaagai.org.in" target="_blank"> Vaagai
                    Tecknowledge </a>
                </p>
              </Col>
              <Col lg={4} md={6} sm={12}>
                <div className="footer-social">
                  <a href="#none" aria-label="twitter">
                    <i className="fab fa-twitter"></i>
                  </a>
                  <a href="#none" aria-label="facebook">
                    <i className="fab fa-facebook-square"></i>
                  </a>
                  <a href="#none" aria-label="youtube">
                    <i className="fab fa-youtube"></i>
                  </a>
                  <a href="#none" aria-label="instagram">
                    <i className="fab fa-instagram"></i>
                  </a>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <br />
                <p className="text-center">{this.state.VersionInfo}</p>
              </Col>
            </Row>
          </div>
        </div>
      </section >
    );
  }
}

export default Footer;
